module.exports = __webpack_public_path__ + "cb9bc0c2.png";